import React from "react";

function DocumentNameInput({ name, setName, dirty }) {
  return (
    <label className="font-semibold text-2xl w-full">
      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        className="w-full rounded px-1  mt-1"
        style={{
          border: "none",
          boxShadow: "none",
          color: dirty ? "#b0893e" : "#111", // softer gold-brown for dirty
          fontFamily: "'Courier Prime', 'Courier New', monospace",
          fontWeight: dirty ? 700 : 600,
          transition: "color 0.2s",
        }}
        required
      />
    </label>
  );
}

export default DocumentNameInput;
